import { I18nType } from '@/ui/types/i18n.types';

export default function (i18n: I18nType) {
  const usernameLabel = i18n.getText('Signup', 'labels', 'username');
  const usernamePlaceholder = i18n.getText('Signup', 'placeholders', 'username');

  const gamertagLabel = i18n.getText('Signup', 'labels', 'gamertag');
  const gamertagPlaceholder = i18n.getText('Signup', 'placeholders', 'gamertag');
  const gamertagHint = i18n.getText('Signup', 'hints', 'gamertag');

  const emailLabel = i18n.getText('Signup', 'labels', 'email');
  const emailPlaceholder = i18n.getText('Signup', 'placeholders', 'email');

  const passwordLabel = i18n.getText('Signup', 'labels', 'password');
  const passwordPlaceholder = i18n.getText('Signup', 'placeholders', 'password');
  const passwordHint = i18n.getText('Signup', 'hints', 'password');

  const passwordConfirmLabel = i18n.getText('Signup', 'labels', 'passwordConfirm');
  const passwordConfirmPlaceholder = i18n.getText('Signup', 'placeholders', 'passwordConfirm');
  const cancelLabel = i18n.getText('Signup', 'labels', 'cancel');
  const finishLabel = i18n.getText('Signup', 'labels', 'finish');
  const toLoginLabel = i18n.getText('Signup', 'labels', 'toLogin');

  return {
    usernameLabel,
    usernamePlaceholder,
    gamertagLabel,
    gamertagHint,
    gamertagPlaceholder,
    emailLabel,
    emailPlaceholder,
    passwordLabel,
    passwordPlaceholder,
    passwordHint,
    passwordConfirmLabel,
    passwordConfirmPlaceholder,
    cancelLabel,
    finishLabel,
    toLoginLabel,
  };
}
